import React from "react";
import { Modal, Button } from "react-bootstrap";

const EventShowModal = ({ show, onHide, events = [], date }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="font-20 font-weight-s-bold heading-color" closeButton>
        <Modal.Title className="font-20 font-weight-s-bold heading-color">Events on {date ? date.toDateString() : ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {events.length > 0 ? (
          <div className="d-flex flex-wrap gap-2">
            {events.map((event, i) => (
              <span
                key={i}
                className="px-2 py-1 rounded bg-light text-dark border"
                style={{ fontSize: "13px" }}
              >
                {i + 1}. {event.name}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-muted">No events</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="c-b-btn" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EventShowModal;
